<template>
	<div class="list">
		<div class="list-tt">八字排盘</div>
		<div class="list-tab" v-html="infoHtml"></div>
	</div>
</template>

<script>
	export default {
		props: ['paipan'],
		data() {
			return {
				infoHtml: '',
				getWx: {
					'甲': '木',
					'乙': '木',
					'丙': '火',
					'丁': '火',
					'戊': '土',
					'己': '土',
					'庚': '金',
					'辛': '金',
					'壬': '水',
					'癸': '水',
				},
			}
		},
		methods: {
			getBazi() {
				var bazi = '';
				let type = this.paipan.type;
				let year = this.paipan.year;
				let month = this.paipan.month;
				let day = this.paipan.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.paipan.time];
				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}
				this.infoHtml =
					`
					<table>
						<tr>
							<th></th>
							<th>年柱</th>
							<th>月柱</th>
							<th>日柱</th>
							<th>时柱</th>
						</tr>
						<tr>
							<td>主星</td>
							<td>${bazi.getYearShiShenGan()}</td>
							<td>${bazi.getMonthShiShenGan()}</td>
							<td>${bazi.getDayShiShenGan()}</td>
							<td>${bazi.getTimeShiShenGan()}</td>
						</tr>
						<tr>
							<td>天干</td>
							<td>${bazi.getYearGan()}<span>(${bazi.getYearWuXing()[0]})</span></td>
							<td>${bazi.getMonthGan()}<span>(${bazi.getMonthWuXing()[0]})</span></td>
							<td>${bazi.getDayGan()}<span>(${bazi.getDayWuXing()[0]})</span></td>
							<td>${bazi.getTimeGan()}<span>(${bazi.getTimeWuXing()[0]})</span></td>
						</tr>
						<tr>
							<td>地支</td>
							<td>${bazi.getYearZhi()}<span>(${bazi.getYearWuXing()[1]})</span></td>
							<td>${bazi.getMonthZhi()}<span>(${bazi.getMonthWuXing()[1]})</span></td>
							<td>${bazi.getDayZhi()}<span>(${bazi.getDayWuXing()[1]})</span></td>
							<td>${bazi.getTimeZhi()}<span>(${bazi.getTimeWuXing()[1]})</span></td>
						</tr>
						<tr>
							<td>藏干</td>
							<td>${
								String(bazi.getYearHideGan()).split(',')
								.map(item => {
								    return item.trim() + '<span>(' + (this.getWx[item.trim()] || '') + ')</span>';
								})
								.join('<br>')
							}</td>
							<td>${
								String(bazi.getMonthHideGan()).split(',')
								.map(item => {
								    return item.trim() + '<span>(' + (this.getWx[item.trim()] || '') + ')</span>';
								})
								.join('<br>')
							}</td>
							<td>${
								String(bazi.getDayHideGan()).split(',')
								.map(item => {
								    return item.trim() + '<span>(' + (this.getWx[item.trim()] || '') + ')</span>';
								})
								.join('<br>')
							}</td>
							<td>${
								String(bazi.getTimeHideGan()).split(',')
								.map(item => {
								    return item.trim() + '<span>(' + (this.getWx[item.trim()] || '') + ')</span>';
								})
								.join('<br>')
							}</td>
						</tr>
						<tr>
							<td>副星</td>
							<td>${String(bazi.getYearShiShenZhi()).replace(/,/g, '<br>')}</td>
							<td>${String(bazi.getMonthShiShenZhi()).replace(/,/g, '<br>')}</td>
							<td>${String(bazi.getDayShiShenZhi()).replace(/,/g, '<br>')}</td>
							<td>${String(bazi.getTimeShiShenZhi()).replace(/,/g, '<br>')}</td>
						</tr>
						<tr>
							<td>星运</td>
							<td>${bazi.getYearDiShi()}</td>
							<td>${bazi.getMonthDiShi()}</td>
							<td>${bazi.getDayDiShi()}</td>
							<td>${bazi.getTimeDiShi()}</td>
						</tr>
						<tr>
							<td>空亡</td>
							<td>${bazi.getYearXunKong()}</td>
							<td>${bazi.getMonthXunKong()}</td>
							<td>${bazi.getDayXunKong()}</td>
							<td>${bazi.getTimeXunKong()}</td>
						</tr>
						<tr>
							<td>纳音</td>
							<td>${bazi.getYearNaYin()}</td>
							<td>${bazi.getMonthNaYin()}</td>
							<td>${bazi.getDayNaYin()}</td>
							<td>${bazi.getTimeNaYin()}</td>
						</tr>
					</table>
				`;
			
			},
		},
		watch: {
			paipan(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/bazipai.vue